import type { BaseModalProps } from '@byecode/ui'
import { DesktopModal, Modal } from '@byecode/ui'
import React from 'react'

import ZhiPuAccount from './ZhiPuAccount'

interface ZhiPuAccountModalProps extends BaseModalProps {}

export const ZhiPuAccountModal: React.FunctionComponent<ZhiPuAccountModalProps> = ({ ...rest }) => {
    return (
        <DesktopModal
            width={676}
            {...rest}
            styles={{
                modal: {
                    maxHeight: 'calc(100% - 48px)'
                },
                body: {
                    padding: '0!important'
                },
                header: {
                    borderStyle: 'none'
                }
            }}
        >
            <ZhiPuAccount onClose={rest.onClose} />
        </DesktopModal>
    )
}
